import { Button, Image } from "react-bootstrap";
import cx from "classnames";

import { Sparkle } from "../sparkle";
import styles from "./footer.module.scss";

function FooterStep({ disabled=false, handleContinue, step, loading, handleCancel }) {
  const StoryLineStep = () => {
    return (
      <div className={styles.footer}>
        <p className={styles.footerText}>
          <Image 
            src={"/images/star.svg"}
            alt="star"
            width={14}
            height={14}
          />
          <span>Generate design using this storyline.</span>
        </p>
        <button disabled={disabled} className={styles.button} onClick={handleContinue}>
          <span className={styles.smartGatingContentBorder} />

          <div className={styles.content}>
            <Sparkle />
            <span className={styles.text}>{loading ? "Generating..." : "Generate Design"}</span>
          </div>
        </button>
      </div>
    );
  };

  const DesignStep = () => {
    return (
      <div className={styles.footer}>
        <p className={styles.footerText}>
          <Image 
            src={"/images/star.svg"}
            alt="star"
            width={14}
            height={14}
          />
          <span>Select the vibe.</span>
        </p>
        <Button
          variant="secondary"
          className={styles.cancelButton}
          onClick={handleCancel}
        >
          <span>Cancel</span>
        </Button>
        <Button
          disabled={disabled}
          variant="primary"
          className={styles.nextButton}
          onClick={handleContinue}
        >
          <span>Next</span>
          <i className={cx(styles.icon, "cleverstory-right")} />
        </Button>
      </div>
    );
  };

  const stepContent = () => {
    switch (step) {
      case 2:
        return StoryLineStep();
      case 3:
      case 4:
        return DesignStep();
      default:
        return <></>;
    }
  };

  return stepContent();
}

export default FooterStep;
